<template>
    <b-loading :active="true"></b-loading>
</template>

<script>
export default {
}
</script>